import React, { useMemo, useState, useEffect } from "react";
import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import axiosInstance from "../axiosApi";
import { useTranslation } from 'react-i18next';
import {
    MRT_EditActionButtons,
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
//Import Material React Table Translations
import { MRT_Localization_KO } from 'material-react-table/locales/ko';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Checkbox,
    Tooltip,
    FormControlLabel,
    Typography,
    InputLabel,
    useTheme
} from '@mui/material';

import {
    QueryClient,
    QueryClientProvider,
    useMutation,
    useQuery,
    useQueryClient,
} from '@tanstack/react-query';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import TableDatePicker from "./TableDatePicker";
import * as dateFns from "date-fns";

const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
});

function AccessLocationReport() {
    const { t } = useTranslation();
    const [validationErrors, setValidationErrors] = useState({});
    const [startDate, setStartDate] = useState(new Date());
    const [rowSelection, setRowSelection] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { currentLocation, setCurrentLocation } = useAppContext();
    setCurrentLocation('/accesslog');

    //call READ hook
    const {
        data: fetchedaccesslocation = [],
        isError: isLoadingaccesslocationError,
        isFetching: isFetchingaccesslocation,
        isLoading: isLoadingaccesslocation,
        refetch
    } = useGetAccessLocation();

    const columns = useMemo(
        () => [
            {
                accessorKey: 'user_email', //simple recommended way to define a column
                header: '대상',//optional custom props
                size: 150,
            },
            {
                accessorKey: 'aquisition_path', //simple recommended way to define a column
                header: '취득경로',//optional custom props
                size: 150,
            },
            {
                accessorKey: 'provided_service', //simple recommended way to define a column
                header: '제공서비스',//optional custom props
                size: 150,
            },
            {
                accessorKey: 'receiver_name', //simple recommended way to define a column
                header: '제공받는자',//optional custom props
                size: 150,
            },
            {
                accessorKey: 'crt_date',
                header: '이용일시',
                size: 150,
                Cell: ({ cell }) => {
                    const val = cell.getValue();
                    if (!val) return '';
                    return dateFns.format(new Date(val), 'yyyy년 MM월 dd일 HH:mm:ss');
                },
            },
        ],
        [validationErrors],
    );

    const handleExportData = () => {
        const csv = generateCsv(csvConfig)(fetchedaccesslocation);
        download(csvConfig)(csv);
    };

    const table = useMaterialReactTable({
        columns,
        data: fetchedaccesslocation,
        initialState: {
            density: 'compact',
            pagination: { pageSize: 10, pageIndex: 0 }
        },
        muiTableHeadCellProps: {
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
                fontWeight: 'bold',
                fontSize: '14px',
                backgroundColor: '#D3EFBD',
            },
        },
        enableRowSelection: false,
        enableMultiRowSelection: false,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Data
                </Button>
            </Box>
        ),
    });
    
    //READ hook (get users from api)
    function useGetAccessLocation() {
        return useQuery({
            queryKey: ['accesslocation'],
            queryFn: async () => {
                //console.log(dateFns.format(startDate, "yyyy-MM-dd"));
                const response = await axiosInstance.get('/raxione/accesslocation/', {
                    params: {
                        s_date: dateFns.format(startDate, "yyyy-MM-dd")
                    }
                });
                console.log(response.data);
                return response.data;
            },
        });
    }

    async function onChangeStartDate(event) {
        setStartDate(startDate => event);
    }

    useEffect(() => {
        refetch();
    }, [startDate]);

    return (
        <Box m="10px">
            <Typography variant="h5" fontWeight="bold" mb="10px">
                위치정보 이용/제공 대장
            </Typography>
            <Box sx={{ display: 'flex', marginTop: 3 }}>
                <InputLabel>기준일자 : </InputLabel>

                <TableDatePicker
                    wrapperClassName="datepicker"
                    selected={startDate}
                    onChange={onChangeStartDate}
                />
            </Box>
            <Box
                mt="10px"
            >
                <MaterialReactTable table={table} />
            </Box>

        </Box>);
}

export default AccessLocationReport;